<app-base-template>
  <h1 [innerHTML]="'pages.connection.title' | translate"></h1>
  <h2 [innerHTML]="'pages.connection.subtitle' | translate"></h2>
  <div class="stepper-list">
    <app-stepper-item icon="download" [completionPercent]="25" [stepIndex]="1"
      content="pages.connection.steps.download" />
    <app-stepper-item icon="user" [completionPercent]="50" [stepIndex]="2"
      content="pages.connection.steps.create_account" />
    <app-stepper-item icon="connexion" [completionPercent]="75" [stepIndex]="3"
      content="pages.connection.steps.connect_device" />
    <app-stepper-item icon="qrcode" [completionPercent]="100" [stepIndex]="4" [isLast]="true"
      content="pages.connection.steps.scan_qr" />
  </div>
  <app-connection-code />
</app-base-template>